// extracted by mini-css-extract-plugin
export default {"f5gOptionSingleLabel":"OptionTruncationOnly_f5gOptionSingleLabel__LHYO8"};